import { accentColorConfig } from '@hooks/useAccentColor'
import { AccentColor } from '@typings/index'
import { motion } from 'framer-motion'

interface TypingLoaderProps {
  accentColor: AccentColor
}

const TypingLoader = ({ accentColor }: TypingLoaderProps) => {
  // Variants for the dots
  const dotVariants = {
    animate: (i: number) => ({
      y: [0, -7, 0], // Moving up and down to create bounce effect
      transition: {
        duration: 0.6, // Duration for the full up and down animation
        repeat: Infinity, // Repeat the animation forever
        ease: 'easeInOut',
        delay: i * 0.1, // Adding delay based on dot index
      },
    }),
  }

  return (
    <div className="flex items-center justify-start mt-5 ml-2">
      {[0, 1, 2].map((i) => (
        <motion.span
          key={i}
          className={`${accentColorConfig[accentColor].primary} w-2.5 h-2.5 mx-0.5 rounded-full`}
          custom={i}
          variants={dotVariants}
          animate="animate"
        />
      ))}
    </div>
  )
}

export default TypingLoader
